import type PaginationResultApiModel from '../../../services/pagination-result.api-model';
import type { IPaginationResult } from '../../../models/pagination-result.model';
import type IPressContact from '../../../models/press/press-contact.model';
import { PressContactApiModel } from './press-contact.api-model';

export class PressContactsApiModel {
  public static mapToBusinessModel(apiModel: PaginationResultApiModel<PressContactApiModel>): IPaginationResult<IPressContact> {
    return {
      results: apiModel.results.map(PressContactApiModel.mapToBusinessModel),
      count: apiModel.count,
      totalCount: apiModel.totalCount,
      links: {
        current: apiModel.links?.current,
        next: apiModel.links?.next,
        previous: apiModel.links?.previous,
      },
    };
  }
}

